import { API_NOT_BOOKABLE } from './constants';

function isBookable(availability: string | null): boolean {
  return !!availability && !API_NOT_BOOKABLE.includes(availability);
}

export { isBookable };
